import { urlTools } from '../../utils/tools/urlTools';
import { ENDPOINTS_NAMES } from '../common/endpointsNames';
import environments from './environments';
import mode from './mode';

const customConfigName = __CUSTOM_CONFIG__ ? __CUSTOM_CONFIG__ : null;

const {
    ADD_MEMBER,
    ANNOUNCEMENTS,
    APPLICATIONS_NEW,
    AGENT_LEFT_NAV_PARAMS,
    BLOOD_RELATIONSHIPS_CHECK,
    BLOOD_RELATIONSHIPS_ENDPOINT,
    BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST,
    BROKERCONNECT_DATA,
    BROKERCONNECT_PARTICIPATION_DETAILS,
    BROKERCONNECT_HOURS,
    BROKERCONNECT_AVAILABILITY,
    CHANGE_LANGUAGE,
    CHANGE_APP_STATUS,
    CHECK_FOR_PENDING_APPLICATION,
    COMMENTS,
    COMMUNICATION_PREFERENCES,
    OTP_VERIFY,
    OTP_SEND,
    PARTIAL_UPDATE,
    TELEX_ENVIRONMENT,
    COUNTY_ENDPOINT,
    COUNTRIES_ENDPOINT,
    COUNTIES_FOR_STATE_ENDPOINT,
    COUNTIES_FOR_STATES_ENDPOINT,
    DASHBOARD_MODELS,
    DASHBOARD_MODELS_LITE,
    DELEGATION_HISTORY,
    DISENROLL_MEMBERS,
    DOCUMENTS_VERIFICATION_DATA,
    DOCUMENTS_VERIFICATION_ENDPOINT,
    EDE_ID_PROOFING_ENDPOINT,
    EDE_SEARCH_ENDPOINT,
    EDE_SEARCH_ADD_TO_BOB,
    ELIGIBILITY_RESULTS_NEW,
    MEMBER_ENROLLMENT_LIST_DETAILS,
    MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS,
    MEMBER_ENROLLMENT_DETAILS,
    MEMBER_ENROLLMENT_LIST_PERMISSIONS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE,
    MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY,
    MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT,
    ENVIRONMENT_VARIABLES,
    EXTERNAL_CONTENT,
    CUSTOM_GROUPING_DETAIL,
    TOBACCO_EXEMPT_GET_APPLICANTS,
    GET_ENROLLMENT_HISTORY,
    GET_SSN_DETAILS,
    GET_IVR_DATA,
    GET_UNREAD_NOTIFICATION_COUNT,
    FLOW_ENDPOINT,
    HTML_2_PDF_SCRIPT_ENDPOINT,
    INITIAL_DATA_ENDPOINT,
    IVM_DOWNLOAD_DOCUMENT,
    IVM_ENVIRONMENT,
    IVM_ISSUER_LIST,
    IVM_PREVIEW_PACKET,
    IVM_PREVIEW_STATEMENT,
    IVM_RESEND_PACKETS,
    IVM_REVIEW_PACKET,
    IVM_SEND_PACKET,
    IVM_STATEMENT_PACKETS,
    IVM_UPDATE_EMAIL_PHONE,
    IVM_UPDATE_COMMENTS,
    LCE_CLONE,
    MOCKS,
    MODAL_MOCKS,
    MEMBER_AFFORDABILITY,
    MULTIHOUSEHOLD_DETAILS,
    NAV_BAR,
    NOTIFICATIONS,
    PAY_FOR_HEALTH,
    CHANGE_TERMINATION_DATE,
    PING,
    PRE_ELIGIBILITY_BROWSE_PLANS,
    PRE_ELIGIBILITY_CALCULATE_SAVINGS,
    PRE_ELIGIBILITY_RESULTS_APTC_IMAGE,
    PRE_ELIGIBILITY_RESULTS_CSR_IMAGE,
    PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE,
    PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE,
    PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE,
    PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE,
    PRE_ELIGIBILITY_RESULTS_NA_IMAGE,
    PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE,
    PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE,
    TRIBES_ENDPOINT,
    PRE_ELIGIBILITY,
    POST_TICKET,
    SAVE_COMMENTS,
    SAVE_CUSTOM_GROUPING,
    SAVE_DATA_ENDPOINT,
    SCREENPOP_ASSISTER_DATA,
    SCREENPOP_BROKER_DATA,
    SEARCH_APPLICANT,
    START_SHOPPING,
    START_SSAP_BY_CASE_NUMBER,
    START_SSAP_BY_YEAR,
    VERIFY_ACCESS_CODE,
    TERMINATE_DENTAL_PLAN,
    TERMINATE_HEALTH_PLAN,
    TERMINATE_PLAN,
    TICKET_TYPES,
    TICKETS,
    TICKET_MGMT_CATEGORIES,
    TICKET_MGMT_GET_TAGS,
    TICKET_MGMT_UPDATE_TAG,
    TICKET_MGMT_WORKGROUPS_TAGS,
    TICKET_MGMT_EXCHANGE_ASSIGNEES,
    TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES,
    TICKET_MGMT_TICKET_DETAIL_BACKDOOR,
    TICKET_MGMT_GET_CONSUMER_DATA,
    TICKET_MGMT_PERMISSIONS,
    TICKET_MGMT_WORKGROUPS,
    TICKET_MGMT_WORKFLOW_TYPES,
    TICKET_MGMT_WORKFLOW_BY_CATEGORY,
    TOBACCO_EXEMPT_SAVE_ADDINFO,
    UNREAD_MESSAGE_COUNT,
    VALIDATE_ADDRESS_ENDPOINT,
    ZIPCODE_COUNTIES,
    VERIFICATION_PENDING,
    ENTITY_SITE_LIST,
    SEARCH_CEC,
    FILTER_CEC_ENTITYADMIN,
    PARTNER_BROKER,
    PRE_OEP_LANDING,
    WORKGROUP_BY_STATUS,
    WORKGROUP_BY_DUEDATE,
    WORKGROUP_BY_USER,
    WORKGROUP_DUEDATE_REPORT_BY_USER,
    GET_USER_SECURITY_DETAILS,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE,
    RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN,
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
    RIDP_CURRENT_USER_INFO_ENDPOINT,
    RIDP_VIEWREF_ENDPOINT,
    RIDP_VALIDATE_PRIMARY_ENDPOINT,
    RIDP_VALIDATE_SECONDARY_ENDPOINT,
    RIDP_MANUAL_VERIFICATION_ENDPOINT,
    RIDP_VALIDATE_FARS_ENDPOINT,
    RIDP_CLEAR_DHS_ENDPOINT,
    DMI_GET_DMI_VERIFICATIONS,
    DMI_VLP_VERIFICATIONS,
    DMI_GET_HOUSEHOLD_INCOME,
    DMI_UPLOAD_DOCUMENT_ENDPOINT,
    DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT,
    UPLOADED_DOCUMENT_URL,
    MEMBER_APP_LIST_CONTROLLER,
    MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS,
    MEMBER_APP_LIST_GET_APPS,
    MEMBER_APP_LIST_OVERRIDE_COMMENT,
    MEMBER_APP_LIST_INIT_VERIFICATIONS,
    MEMBER_APP_LIST_RERUN_ELIGIBILITY,
    MEMBER_APP_LIST_TERMINATE_PLAN,
    MEMBER_APP_LIST_REVERSE_DENIAL,
    MEMBER_APP_LIST_UPDATE_CARRIER,
    MEMBER_APP_LIST_SAVE_SEP_DETAILS,
    MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS,
    MEMBER_APP_LIST_SEND_OBAT,
    MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS,
    MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP,
    MEMBER_APP_LIST_CHECK_ACTIVE,
    MEMBER_APP_LIST_PROGRAM_ELIGIBILITY,
    MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY,
    MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT,
    MEMBER_APP_LIST_SEP_EVENT_DETAILS,
    MEMBER_APP_LIST_GET_SEP_DETAILS,
    MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK,
    MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS,
    MEMBER_APP_LIST_GET_SEP_PERIOD_DATES,
    MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE,
    MEMBER_APP_LIST_GET_QHP_APPLICANTS,
    MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW,
    MEMBER_APP_LIST_NEW_SSAP_START,
    MEMBER_APP_LIST_APPLICATIONS,
    MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER,
    MEMBER_ACCOUNT_ACTIVITY_DETAILS,
    MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS,
    MEMBER_ACCOUNT_ACTIVITY_LOG_CALL,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY,
    MEMBER_ACCOUNT_ACTIVITY_INIT_CALL,
    DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT,
    DMI_OVERRIDE_DOCUMENTS,
    DMI_LOAD_DOCUMENT_ENDPOINT,
} = ENDPOINTS_NAMES;

const endpointsValues = {
    [HTML_2_PDF_SCRIPT_ENDPOINT]: '/scripts/html2pdf.bundle.js',
    config3: {
        [BLOOD_RELATIONSHIPS_ENDPOINT]: '/ssap/relationships',
        [BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST]: '/ssap/commonRelationships',
        [ENVIRONMENT_VARIABLES]: '/web/ui/environment',
        [DASHBOARD_MODELS]: '/ssap/dashboard',
        [COUNTY_ENDPOINT]: '/web/countiesforstate/',
        [COUNTRIES_ENDPOINT]: '/web/countrylist',
        [COUNTIES_FOR_STATE_ENDPOINT]: '/web/countiesforstate/',
        [COUNTIES_FOR_STATES_ENDPOINT]: '/web/countiesforstates/',
        [FLOW_ENDPOINT]: '/ssap/configuration',
        [INITIAL_DATA_ENDPOINT]: '/ssap/application/',
        [MEMBER_AFFORDABILITY]: '/ssap/configuration/affordability/',
        [PRE_ELIGIBILITY]: '/ssap/preeligibility/',
        [SAVE_DATA_ENDPOINT]: '/ssap/save?ignore=',
        [START_SHOPPING]: '/preeligibility',
        [START_SSAP_BY_CASE_NUMBER]: '/ssap?caseNumber=${caseNumber}',
        [START_SSAP_BY_YEAR]: '/ssap?coverageYear=${applicationYear}',
        [TRIBES_ENDPOINT]: '/web/stateswithtribes',
        [VERIFICATION_PENDING]: '/ssap/pendingVerification',
        [VALIDATE_ADDRESS_ENDPOINT]: '/web/address/validate',
        [UNREAD_MESSAGE_COUNT]: 'inbox/secureInboxUnread',
    },
    config99: {
        [PAY_FOR_HEALTH]: '/mocks/individualPortal/payforhealth',
        [CHANGE_TERMINATION_DATE]: '/mocks/individualPortal/changeTerminationDate',
        [GET_ENROLLMENT_HISTORY]: '/mocks/individualPortal/enrollmentHistoryAll.json',
        [GET_SSN_DETAILS]: '/mocks/member/ssnDetails.json',
        [ADD_MEMBER]: '/mocks/member/addMember.json',
        [ANNOUNCEMENTS]: '/mocks/announcements.json',
        [APPLICATIONS_NEW]: '/mocks/individualPortal/applications.json',
        [AGENT_LEFT_NAV_PARAMS]: '/mocks/agentLeftNav.json',
        [BLOOD_RELATIONSHIPS_CHECK]: '/mocks/bloodRelationshipsCheck.json',
        [BLOOD_RELATIONSHIPS_ENDPOINT]: '/mocks/bloodrelationships/bloodRelationships_${stateCode}.json',
        [BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST]: '/mocks/commonRelationships.json',
        [BROKERCONNECT_DATA]: '/mocks/brokerConnect/brokerConnect.json',
        [BROKERCONNECT_PARTICIPATION_DETAILS]: '/mocks/brokerConnect/brokerConnect.json',
        [BROKERCONNECT_HOURS]: '/mocks/brokerConnect/brokerConnect.json',
        [BROKERCONNECT_AVAILABILITY]: '/mocks/brokerConnect/brokerConnect.json',
        [CHANGE_LANGUAGE]: '/mocks/language_${language}.json',
        [CHANGE_APP_STATUS]: '/mocks/individualPortal/changeAppStatus.json',
        [CHECK_FOR_PENDING_APPLICATION]: '/mocks/customGrouping/checkForPendingApplication.json',
        [COMMENTS]: '/mocks/comment.json',
        [COMMUNICATION_PREFERENCES]: '/mocks/individualPortal/communicationPreferences.json',
        [OTP_VERIFY]: '/mocks/individualPortal/otpVerify.json',
        [OTP_SEND]: '/mocks/individualPortal/otpSend.json',
        [PARTIAL_UPDATE]: '/mocks/individualPortal/partialUpdate.json',
        [TELEX_ENVIRONMENT]: '/mocks/individualPortal/telexEnvironment.json',
        [COUNTIES_FOR_STATE_ENDPOINT]: '/mocks/counties/${state}-${postalCode}.json',
        [COUNTRIES_ENDPOINT]: '/mocks/countries.json',
        [CUSTOM_GROUPING_DETAIL]: '/mocks/customGrouping/customGrouping.json',
        [DASHBOARD_MODELS]: '/mocks/individualPortal/getDashboardModels.json',
        [DASHBOARD_MODELS_LITE]: '/mocks/individualPortal/dashboardModelsLite.json',
        [DELEGATION_HISTORY]: '/mocks/delegations.json?pageNumber=${pageNumber}',
        [DISENROLL_MEMBERS]: '/mocks/customGrouping/disenrollMembers.json',
        [DOCUMENTS_VERIFICATION_DATA]: '/mocks/documentsVerification/qle${stateCode}.json',
        [DOCUMENTS_VERIFICATION_ENDPOINT]: '/mp/documents',
        [EDE_ID_PROOFING_ENDPOINT]: '/mocks/broker/verifyIdentity.json',
        [EDE_SEARCH_ENDPOINT]: '/mocks/broker/edeSearch.json',
        [EDE_SEARCH_ADD_TO_BOB]: '/mocks/broker/addedToBOB.json',
        [ELIGIBILITY_RESULTS_NEW]: '/mocks/individualPortal/eligibilityResults.json',
        [ENVIRONMENT_VARIABLES]: '/mocks/ui/environment/${stateCode}.json',
        [MEMBER_ENROLLMENT_LIST_DETAILS]: '/mocks/memberEnrollmentList/enrollmentdetails.json',
        [MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS]: '/mocks/memberEnrollmentList/enrollmentAndEnrolleeDetails.json',
        [MEMBER_ENROLLMENT_DETAILS]: '/mocks/memberEnrollmentList/enrollmentIdDetail.json',
        [MEMBER_ENROLLMENT_LIST_PERMISSIONS]: '/mocks/memberEnrollmentList/permissions.json',
        [MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT]: '/mocks/memberEnrollmentList/getEnrollmentSnapshot.json',
        [MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT]: '/mocks/memberEnrollmentList/resendComment.json',
        [MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS]:
            '/mocks/memberEnrollmentList/reinstateEnrollmentStatus.json',
        [MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS]: '/mocks/memberEnrollmentList/updateEnrollmentStatus.json',
        [MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE]: '/mocks/memberEnrollmentList/cancelActiveEnrollment.json',
        [MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY]:
            '/mocks/memberEnrollmentList/cancelPremiumHistoryEnrollment.json',
        [MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT]: '/mocks/memberEnrollmentList/updateEnrollment.json',
        [EXTERNAL_CONTENT]: '/mocks/explainerData.json',
        [FLOW_ENDPOINT]: '/mocks/ssapFlow.json',
        [TOBACCO_EXEMPT_GET_APPLICANTS]: '/mocks/individualPortal/getApplicantsForAddInfo.json',
        [TOBACCO_EXEMPT_SAVE_ADDINFO]: '/mocks/individualPortal/saveAdditionalInfo.json',
        [GET_IVR_DATA]: '/mocks/screenpop/ivrData.json',
        [GET_UNREAD_NOTIFICATION_COUNT]: '/mocks/count.json',
        [INITIAL_DATA_ENDPOINT]: '/mocks/ssapjsons/${jsonName}.json',
        [IVM_DOWNLOAD_DOCUMENT]: '/mocks/invoicingManagement/{filename}',
        [IVM_ENVIRONMENT]: '/mocks/invoicingManagement/environment.json',
        [IVM_ISSUER_LIST]: '/mocks/invoicingManagement/issuerlist.json',
        [IVM_PREVIEW_PACKET]: '/mocks/invoicingManagement/previewPacket.json',
        [IVM_PREVIEW_STATEMENT]: '/mocks/downloadDocuments/{fileName}',
        [IVM_RESEND_PACKETS]: '/mocks/invoicingManagement/resendPacket.json',
        [IVM_REVIEW_PACKET]: '/mocks/invoicingManagement/reviewPacket.json',
        [IVM_SEND_PACKET]: '/mocks/invoicingManagement/sendPacket.json',
        [IVM_STATEMENT_PACKETS]: '/mocks/invoicingManagement/statementPackets.json',
        [IVM_UPDATE_EMAIL_PHONE]: 'mocks/invoicingManagement/updateEmailPhone.json',
        [IVM_UPDATE_COMMENTS]: 'mocks/invoicingManagement/updateCommentsForStatement.json',
        [LCE_CLONE]: '/mocks/individualPortal/lceClone.json',
        [NAV_BAR]: '/mocks/navBar.json',
        [NOTIFICATIONS]: '/mocks/inbox_messages.json',
        [MEMBER_ACCOUNT_ACTIVITY_DETAILS]: '/mocks/account-activity/memberAccountActivityDetails.json',
        [MEMBER_ACCOUNT_ACTIVITY_LOG_CALL]: '/mocks/account-activity/memberAccountActivityLogCall.json',
        [MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE]: '/mocks/account-activity/memberAccountActivityAddCallNote.json',
        [MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE]: '/mocks/account-activity/memberAccountActivityAddChatNote.json',
        [MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY]: '/mocks/account-activity/memberAccountActivityExportHistory.json',
        [MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS]: '/mocks/account-activity/memberAccountActivityEventComments.json',
        [MEMBER_ACCOUNT_ACTIVITY_INIT_CALL]: '/mocks/account-activity/memberAccountActivityInitCall.json',
        [MEMBER_AFFORDABILITY]: '/mocks/memberAffordability/affordability_${coverageYear}.json',
        [MOCKS]: '/mocks/${jsonName}.json',
        [MODAL_MOCKS]: '/mocks/modals.json',
        [MULTIHOUSEHOLD_DETAILS]: '/mocks/individualPortal/multihouseholdDetails.json',
        [PING]: '/mocks/ping.json',
        [PRE_ELIGIBILITY_BROWSE_PLANS]: '/private/preferences',
        [PRE_ELIGIBILITY_CALCULATE_SAVINGS]: '/mocks/prescreenResults.json',
        [PRE_ELIGIBILITY_RESULTS_APTC_IMAGE]: '/assets/images/${statecode}/money.png',
        [PRE_ELIGIBILITY_RESULTS_CSR_IMAGE]: '/assets/images/${statecode}/chart.png',
        [PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE]: '/assets/images/${statecode}/children.png',
        [PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE]: '/assets/images/${statecode}/shield.png',
        [PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE]: '/assets/images/${statecode}/grandparents.png',
        [PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE]: '/assets/images/${statecode}/family.png',
        [PRE_ELIGIBILITY_RESULTS_NA_IMAGE]: '/assets/images/${statecode}/shield.png',
        [PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE]: '/assets/images/${statecode}/courthouse.png',
        [PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE]: '/assets/images/${statecode}/shield.png',
        [VERIFICATION_PENDING]: '/mocks/verificationPending.json',
        [VERIFY_ACCESS_CODE]: '/referral/checkaccesscode?accessCode=${accessCode}',
        [POST_TICKET]: '/mocks/individualPortal/postTicket.json',
        [SAVE_COMMENTS]: '/mocks/postcomment.json',
        [SAVE_CUSTOM_GROUPING]: '/mocks/customGrouping/saveCustomGrouping.json',
        [SCREENPOP_ASSISTER_DATA]: '/mocks/screenpop/assisterData.json',
        [SCREENPOP_BROKER_DATA]: '/mocks/screenpop/brokerData.json',
        [SEARCH_APPLICANT]: '/mocks/screenpop/screenpopSearch.json',
        [TERMINATE_DENTAL_PLAN]: '/mocks/customGrouping/terminateDentalPlan.json',
        [TERMINATE_HEALTH_PLAN]: '/mocks/customGrouping/terminateHealthPlan.json',
        [TERMINATE_PLAN]: '/mocks/customGrouping/terminatePlan.json',
        [TICKET_MGMT_CATEGORIES]: '/mocks/ticketMgmt/categories.json',
        [TICKET_MGMT_GET_TAGS]: '/mocks/ticketMgmt/tags.json',
        [TICKET_MGMT_UPDATE_TAG]: '/mocks/ticketMgmt/updated-tags.json',
        [TICKET_MGMT_WORKGROUPS_TAGS]: '/mocks/ticketMgmt/workgroups-tags-list.json',
        [TICKET_MGMT_EXCHANGE_ASSIGNEES]: '/mocks/ticketMgmt/assignees.json',
        [TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES]: '/mocks/ticketMgmt/updated-assignees.json',
        [TICKET_MGMT_TICKET_DETAIL_BACKDOOR]: '/indportal/switchCSRToTicket/${encTicketId}',
        [TICKET_MGMT_WORKFLOW_TYPES]: '/mocks/ticketMgmt/workflowTypes.json',
        [TICKET_MGMT_WORKFLOW_BY_CATEGORY]: '/mocks/ticketMgmt/workflowsByTicketCategory.json',
        [TICKET_MGMT_WORKGROUPS]: '/mocks/ticketMgmt/workgroups.json',
        [TICKET_MGMT_PERMISSIONS]: '/mocks/ticketMgmt/permissions.json',
        [TICKET_MGMT_GET_CONSUMER_DATA]: '/mocks/ticketMgmt/sendSecureMsg.json',
        [TICKET_TYPES]: '/mocks/individualPortal/ticketTypes.json',
        [TICKETS]: '/mocks/individualPortal/ticket.json',
        [TRIBES_ENDPOINT]: '/mocks/tribes.json',
        [UNREAD_MESSAGE_COUNT]: '/mocks/secureInboxUnread.json',
        [VALIDATE_ADDRESS_ENDPOINT]: '/mocks/validateAddress.json',
        [ZIPCODE_COUNTIES]: '/mocks/counties.json',
        [SEARCH_CEC]: '/mocks/filterCEC.json',
        [ENTITY_SITE_LIST]: '/mocks/entitySiteList.json',
        [FILTER_CEC_ENTITYADMIN]: '/mocks/entityAdminCecList.json',
        [PARTNER_BROKER]: '/mocks/individualPortal/partnerBroker.json',
        [WORKGROUP_BY_STATUS]: '/mocks/chartData/workgroupByStatus.json',
        [WORKGROUP_BY_DUEDATE]: '/mocks/chartData/workgroupByDueDate.json',
        [WORKGROUP_BY_USER]: '/mocks/chartData/dueDateByUser.json',
        [WORKGROUP_DUEDATE_REPORT_BY_USER]: '/mocks/chartData/dueDateReportByUser.json',
        [GET_USER_SECURITY_DETAILS]: '/mocks/user-security-details.json',
        [RESOLVED_DATE_REPORTS_BY_WORKGROUP]: '/mocks/chartData/getResolvedDateReportsByWorkGroup.json',
        [RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE]:
            '/mocks/chartData/getResolvedDateReportsByWorkGroupAssignee.json',
        [RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN]:
            '/mocks/chartData/getResolvedDateReportsByWorkGroupAssignee.json',
        [RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN]:
            '/mocks/chartData/getResolvedDateReportsByWorkGroup.json',
        [RIDP_CURRENT_USER_INFO_ENDPOINT]: '/mocks/ridp/getCurrentUserInfo.json',
        [RIDP_VIEWREF_ENDPOINT]: '/mocks/ridp/getViewRef.json',
        [RIDP_VALIDATE_PRIMARY_ENDPOINT]: '/mocks/ridp/getRidpValidatePrimaryResponse.json',
        [RIDP_VALIDATE_SECONDARY_ENDPOINT]: '/mocks/ridp/getValidateRidpSecondary.json',
        [RIDP_MANUAL_VERIFICATION_ENDPOINT]: '/mocks/ridp/getManualVerificationUploadResponse.json',
        [RIDP_VALIDATE_FARS_ENDPOINT]: '/mocks/ridp/getValidateFARS.json',
        [RIDP_CLEAR_DHS_ENDPOINT]: '/mocks/ridp/getClearDHSReference.json',
        [UPLOADED_DOCUMENT_URL]: '${encryptedDocumentPath}',
        [MEMBER_APP_LIST_CONTROLLER]: '/mocks/getCapController.json',
        [MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS]: '/mocks/getCapOutBoundButtonStatus.json',
        [MEMBER_APP_LIST_GET_APPS]: '/mocks/getCapApplications2025.json',
        [MEMBER_APP_LIST_OVERRIDE_COMMENT]: '/mocks/addOverrideComment.json',
        [MEMBER_APP_LIST_INIT_VERIFICATIONS]: '/mocks/initVerifications.json',
        [MEMBER_APP_LIST_RERUN_ELIGIBILITY]: '/mocks/rerunEligibility.json',
        [MEMBER_APP_LIST_TERMINATE_PLAN]: '/mocks/terminatePlan.json',
        [MEMBER_APP_LIST_REVERSE_DENIAL]: '/mocks/reverseDenial.json',
        [MEMBER_APP_LIST_UPDATE_CARRIER]: '/mocks/updateCarrier.json',
        [MEMBER_APP_LIST_SAVE_SEP_DETAILS]: '/mocks/saveSepDetails.json',
        [MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS]: '/mocks/saveSepOverrideDetails.json',
        [MEMBER_APP_LIST_SEND_OBAT]: '/mocks/sendObat.json',
        [MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS]: '/mocks/updateEnrollmentStatus.json',
        [MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP]: '/mocks/overrideApplicationEndSep.json',
        [MEMBER_APP_LIST_CHECK_ACTIVE]: '/mocks/checkActive.json',
        [MEMBER_APP_LIST_PROGRAM_ELIGIBILITY]: '/mocks/getProgrmeEligibility.json',
        [MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY]: '/mocks/overrideProgrmeEligibility.json',
        [MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT]: '/mocks/addOverrideComment.json',
        [MEMBER_APP_LIST_SEP_EVENT_DETAILS]: '/mocks/getSepEventDetails.json',
        [MEMBER_APP_LIST_GET_SEP_DETAILS]: '/mocks/getSepDetails.json',
        [MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK]: '/mocks/overrideApplicationLock.json',
        [MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS]: '/mocks/getEligibilityDateDetails.json',
        [MEMBER_APP_LIST_GET_SEP_PERIOD_DATES]: '/mocks/getSepPeriodDates.json',
        [MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE]: '/mocks/getSepEventsByApplicationType.json',
        [MEMBER_APP_LIST_GET_QHP_APPLICANTS]: '/mocks/getQHPApplicants.json',
        [MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW]: '/mocks/saveShoppingWindow.json',
        [MEMBER_APP_LIST_NEW_SSAP_START]:
            '/account/user/switchUserRole?switchToModuleName=${switchToModuleName}&switchToModuleId=${switchToModuleId}&switchToResourceName=${switchToResourceName}&switchToNonDefaultURL=/indportal/editapplication?caseNumber=${caseNumber}',
        [MEMBER_APP_LIST_APPLICATIONS]: '/cap/member/applications/${encHouseHoldId}',
        [MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER]: '/mocks/cloneApplicationByCaseNumber.json',
        [DMI_GET_DMI_VERIFICATIONS]: '/mocks/getVerificationsData.json',
        [DMI_VLP_VERIFICATIONS]: '/mocks/vlpVerificationsData.json',
        [DMI_GET_HOUSEHOLD_INCOME]: '/mocks/getHouseholdIncomeData.json',
        [DMI_UPLOAD_DOCUMENT_ENDPOINT]: '/mocks/getVerificationsDocumentUploadData.json',
        [DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT]: '/mocks/getVerificationsDocumentUploadQrCodeData.json',
        [DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT]: '/mocks/getVerificationsDocumentDeleteData.json',
        [DMI_OVERRIDE_DOCUMENTS]: '/mocks/getVerificationsDocumentOverrideData.json',
        [DMI_LOAD_DOCUMENT_ENDPOINT]: '/mocks/getVerificationsDocumentLoadData.json',
    },
};

const isCustom = mode === environments.CUSTOM;

const endpointsReplacements = {
    config3: [
        {
            hostName: 'http://localhost:8081',
            customHostName: null,
            prefix: '',
            customPrefix: null,
            endpoints: [
                COUNTY_ENDPOINT,
                COUNTRIES_ENDPOINT,
                COUNTIES_FOR_STATE_ENDPOINT,
                COUNTIES_FOR_STATES_ENDPOINT,
                ENVIRONMENT_VARIABLES,
                DASHBOARD_MODELS,
                TRIBES_ENDPOINT,
                VALIDATE_ADDRESS_ENDPOINT,
            ],
        },
        {
            hostName: 'http://localhost:8089',
            customHostName: null,
            prefix: '',
            customPrefix: null,
            endpoints: [
                BLOOD_RELATIONSHIPS_ENDPOINT,
                BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST,
                DASHBOARD_MODELS,
                FLOW_ENDPOINT,
                INITIAL_DATA_ENDPOINT,
                MEMBER_AFFORDABILITY,
                PRE_ELIGIBILITY,
                SAVE_DATA_ENDPOINT,
                VERIFICATION_PENDING,
            ],
        },
        {
            hostName: 'http://localhost:7777',
            customHostName: null,
            prefix: '',
            customPrefix: null,
            endpoints: [HTML_2_PDF_SCRIPT_ENDPOINT, START_SSAP_BY_CASE_NUMBER, START_SSAP_BY_YEAR],
        },
    ],
    config99: [
        {
            hostName: 'http://localhost:8080',
            customHostName: null,
            prefix: '/hix',
            customPrefix: null,
            endpoints: [
                VERIFY_ACCESS_CODE,
                EDE_ID_PROOFING_ENDPOINT,
                EDE_SEARCH_ENDPOINT,
                RIDP_CURRENT_USER_INFO_ENDPOINT,
                RIDP_VIEWREF_ENDPOINT,
                RIDP_MANUAL_VERIFICATION_ENDPOINT,
                RIDP_VALIDATE_FARS_ENDPOINT,
                RIDP_CLEAR_DHS_ENDPOINT,
                MEMBER_APP_LIST_GET_APPS,
                MEMBER_APP_LIST_CONTROLLER,
                MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS,
                MEMBER_APP_LIST_RERUN_ELIGIBILITY,
                MEMBER_APP_LIST_TERMINATE_PLAN,
                MEMBER_APP_LIST_REVERSE_DENIAL,
                MEMBER_APP_LIST_UPDATE_CARRIER,
                MEMBER_APP_LIST_PROGRAM_ELIGIBILITY,
                MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY,
                MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT,
                MEMBER_APP_LIST_SAVE_SEP_DETAILS,
                MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS,
                MEMBER_APP_LIST_SEND_OBAT,
                MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS,
                MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP,
                MEMBER_APP_LIST_CHECK_ACTIVE,
                MEMBER_APP_LIST_GET_SEP_DETAILS,
                MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK,
                MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS,
                MEMBER_APP_LIST_GET_SEP_PERIOD_DATES,
                MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE,
                MEMBER_APP_LIST_GET_QHP_APPLICANTS,
                MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW,
                MEMBER_APP_LIST_NEW_SSAP_START,
                MEMBER_APP_LIST_APPLICATIONS,
                MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER,
            ],
        },
        {
            hostName: 'http://localhost:8888',
            customHostName: null,
            prefix: '',
            customPrefix: null,
            endpoints: [
                ADD_MEMBER,
                APPLICATIONS_NEW,
                ANNOUNCEMENTS,
                AGENT_LEFT_NAV_PARAMS,
                BLOOD_RELATIONSHIPS_CHECK,
                BLOOD_RELATIONSHIPS_ENDPOINT,
                BLOOD_RELATIONSHIPS_ENDPOINT_WHOLE_LIST,
                BROKERCONNECT_DATA,
                BROKERCONNECT_PARTICIPATION_DETAILS,
                BROKERCONNECT_HOURS,
                BROKERCONNECT_AVAILABILITY,
                CHANGE_LANGUAGE,
                CHANGE_APP_STATUS,
                CHECK_FOR_PENDING_APPLICATION,
                COMMUNICATION_PREFERENCES,
                OTP_VERIFY,
                OTP_SEND,
                PARTIAL_UPDATE,
                TELEX_ENVIRONMENT,
                COUNTIES_FOR_STATE_ENDPOINT,
                COUNTRIES_ENDPOINT,
                CUSTOM_GROUPING_DETAIL,
                GET_ENROLLMENT_HISTORY,
                DASHBOARD_MODELS,
                DASHBOARD_MODELS_LITE,
                DELEGATION_HISTORY,
                DMI_DELETE_UPLOADED_DOCUMENT_ENDPOINT,
                DMI_OVERRIDE_DOCUMENTS,
                DMI_GET_DMI_VERIFICATIONS,
                DMI_VLP_VERIFICATIONS,
                DMI_GET_HOUSEHOLD_INCOME,
                DMI_LOAD_DOCUMENT_ENDPOINT,
                DMI_UPLOAD_DOCUMENT_ENDPOINT,
                DMI_UPLOAD_DOCUMENT_QR_CODE_ENDPOINT,
                DISENROLL_MEMBERS,
                DOCUMENTS_VERIFICATION_DATA,
                DOCUMENTS_VERIFICATION_ENDPOINT,
                EDE_ID_PROOFING_ENDPOINT,
                EDE_SEARCH_ENDPOINT,
                EDE_SEARCH_ADD_TO_BOB,
                ELIGIBILITY_RESULTS_NEW,
                ENVIRONMENT_VARIABLES,
                MEMBER_ENROLLMENT_LIST_DETAILS,
                MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS,
                MEMBER_ENROLLMENT_DETAILS,
                MEMBER_ENROLLMENT_LIST_PERMISSIONS,
                MEMBER_ENROLLMENT_LIST_ENROLLMENT_DETAIL_SNAPSHOT,
                MEMBER_ENROLLMENT_LIST_ENROLLMENT_RESEND_COMMENT,
                MEMBER_ENROLLMENT_LIST_ENROLLMENT_REINSTATE_STATUS,
                MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_STATUS,
                MEMBER_ENROLLMENT_LIST_ENROLLMENT_CANCEL_ACTIVE,
                MEMBER_ENROLLMENT_LIST_ENVIRONMENT_CANCEL_PREMIUM_HISTORY,
                MEMBER_ENROLLMENT_LIST_ENROLLMENT_UPDATE_ENROLLMENT,
                EXTERNAL_CONTENT,
                FLOW_ENDPOINT,
                TOBACCO_EXEMPT_GET_APPLICANTS,
                TOBACCO_EXEMPT_SAVE_ADDINFO,
                GET_SSN_DETAILS,
                GET_IVR_DATA,
                GET_UNREAD_NOTIFICATION_COUNT,
                INITIAL_DATA_ENDPOINT,
                IVM_DOWNLOAD_DOCUMENT,
                IVM_ENVIRONMENT,
                IVM_ISSUER_LIST,
                IVM_PREVIEW_PACKET,
                IVM_PREVIEW_STATEMENT,
                IVM_RESEND_PACKETS,
                IVM_REVIEW_PACKET,
                IVM_SEND_PACKET,
                IVM_STATEMENT_PACKETS,
                IVM_UPDATE_EMAIL_PHONE,
                IVM_UPDATE_COMMENTS,
                HTML_2_PDF_SCRIPT_ENDPOINT,
                LCE_CLONE,
                MEMBER_AFFORDABILITY,
                MEMBER_ACCOUNT_ACTIVITY_DETAILS,
                MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS,
                MEMBER_ACCOUNT_ACTIVITY_LOG_CALL,
                MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE,
                MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE,
                MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY,
                MEMBER_ACCOUNT_ACTIVITY_INIT_CALL,
                MOCKS,
                MODAL_MOCKS,
                MULTIHOUSEHOLD_DETAILS,
                NAV_BAR,
                NOTIFICATIONS,
                PAY_FOR_HEALTH,
                CHANGE_TERMINATION_DATE,
                PING,
                PRE_ELIGIBILITY_BROWSE_PLANS,
                PRE_ELIGIBILITY_CALCULATE_SAVINGS,
                PRE_ELIGIBILITY_RESULTS_APTC_IMAGE,
                PRE_ELIGIBILITY_RESULTS_CSR_IMAGE,
                PRE_ELIGIBILITY_RESULTS_CHIP_IMAGE,
                PRE_ELIGIBILITY_RESULTS_INELIGIBLE_IMAGE,
                PRE_ELIGIBILITY_RESULTS_MEDICARE_IMAGE,
                PRE_ELIGIBILITY_RESULTS_MEDICAID_IMAGE,
                PRE_ELIGIBILITY_RESULTS_NA_IMAGE,
                PRE_ELIGIBILITY_RESULTS_STATE_SUBSIDY_IMAGE,
                PRE_ELIGIBILITY_RESULTS_ZERO_APTC_IMAGE,
                POST_TICKET,
                SAVE_CUSTOM_GROUPING,
                SCREENPOP_ASSISTER_DATA,
                SCREENPOP_BROKER_DATA,
                SEARCH_APPLICANT,
                TERMINATE_DENTAL_PLAN,
                TERMINATE_HEALTH_PLAN,
                TERMINATE_PLAN,
                TICKET_MGMT_CATEGORIES,
                TICKET_MGMT_GET_TAGS,
                TICKET_MGMT_UPDATE_TAG,
                TICKET_MGMT_WORKGROUPS_TAGS,
                TICKET_MGMT_EXCHANGE_ASSIGNEES,
                TICKET_MGMT_UPDATE_ASSIGNEE_ATTRIBUTES,
                TICKET_MGMT_TICKET_DETAIL_BACKDOOR,
                TICKET_MGMT_GET_CONSUMER_DATA,
                TICKET_MGMT_WORKFLOW_TYPES,
                TICKET_MGMT_WORKFLOW_BY_CATEGORY,
                TICKET_MGMT_WORKGROUPS,
                TICKET_MGMT_PERMISSIONS,
                TICKETS,
                TICKET_TYPES,
                TRIBES_ENDPOINT,
                UNREAD_MESSAGE_COUNT,
                VALIDATE_ADDRESS_ENDPOINT,
                VERIFICATION_PENDING,
                SEARCH_CEC,
                ENTITY_SITE_LIST,
                FILTER_CEC_ENTITYADMIN,
                ZIPCODE_COUNTIES,
                PARTNER_BROKER,
                PRE_OEP_LANDING,
                WORKGROUP_BY_STATUS,
                WORKGROUP_BY_DUEDATE,
                WORKGROUP_BY_USER,
                WORKGROUP_DUEDATE_REPORT_BY_USER,
                GET_USER_SECURITY_DETAILS,
                RESOLVED_DATE_REPORTS_BY_WORKGROUP,
                RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE,
                RESOLVED_DATE_REPORTS_BY_WORKGROUP_ASSIGNEE_DRILL_DOWN,
                RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
                UPLOADED_DOCUMENT_URL,
                RIDP_CURRENT_USER_INFO_ENDPOINT,
                RIDP_VIEWREF_ENDPOINT,
                RIDP_VALIDATE_PRIMARY_ENDPOINT,
                RIDP_VALIDATE_SECONDARY_ENDPOINT,
                RIDP_MANUAL_VERIFICATION_ENDPOINT,
                RIDP_VALIDATE_FARS_ENDPOINT,
                RIDP_CLEAR_DHS_ENDPOINT,
                MEMBER_APP_LIST_CONTROLLER,
                MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS,
                MEMBER_APP_LIST_GET_APPS,
                MEMBER_APP_LIST_OVERRIDE_COMMENT,
                MEMBER_APP_LIST_INIT_VERIFICATIONS,
                MEMBER_APP_LIST_RERUN_ELIGIBILITY,
                MEMBER_APP_LIST_TERMINATE_PLAN,
                MEMBER_APP_LIST_REVERSE_DENIAL,
                MEMBER_APP_LIST_UPDATE_CARRIER,
                MEMBER_APP_LIST_SAVE_SEP_DETAILS,
                MEMBER_APP_LIST_SAVE_SEP_OVERRIDE_DETAILS,
                MEMBER_APP_LIST_SEND_OBAT,
                MEMBER_APP_LIST_UPDATE_ENROLLMENT_STATUS,
                MEMBER_APP_LIST_OVERRIDE_APPLICATION_END_SEP,
                MEMBER_APP_LIST_CHECK_ACTIVE,
                MEMBER_APP_LIST_PROGRAM_ELIGIBILITY,
                MEMBER_APP_LIST_OVERRIDE_PROGRAM_ELIGIBILITY,
                MEMBER_APP_LIST_ADD_OVERRIDE_COMMENT,
                MEMBER_APP_LIST_SEP_EVENT_DETAILS,
                MEMBER_APP_LIST_GET_SEP_DETAILS,
                MEMBER_APP_LIST_OVERRIDE_APPLICATION_LOCK,
                MEMBER_APP_LIST_GET_ELIGIBILITY_DATE_DETAILS,
                MEMBER_APP_LIST_GET_SEP_PERIOD_DATES,
                MEMBER_APP_LIST_GET_SEP_EVENTS_BY_APPLICATION_TYPE,
                MEMBER_APP_LIST_GET_QHP_APPLICANTS,
                MEMBER_APP_LIST_SAVE_SHOPPING_WINDOW,
                MEMBER_APP_LIST_NEW_SSAP_START,
                MEMBER_APP_LIST_APPLICATIONS,
                MEMBER_APP_LIST_CLONE_APPLICATION_BY_CASENUMBER,
            ],
        },
    ],
};

const endpointsConfig =
    customConfigName && endpointsReplacements[customConfigName] ? endpointsReplacements[customConfigName] : [];

export default urlTools.getEndpoints({
    endpointsConfig,
    endpointsValues,
    isCustom,
    customConfigName,
});
